module.exports = __webpack_public_path__ + "assets/img/1_613_big.13dbc283.jpg";